import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { strings } from '@/i18n/strings';

export interface FormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Oynani ochadigan tugma — sahifa uni o'z sarlavhasi yonida joylashtiradi. */
  trigger: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  submitLabel: string;
  submitting?: boolean;
  /** Yuborishni to'sib turadigan shart (masalan rasm hali yuklanmagan). */
  submitDisabled?: boolean;
  onSubmit: (event: React.FormEvent) => void;
  /** Forma xatosi yoki server xatosi — tugmalar USTIDA chiziladi. */
  error?: ReactNode;
  children: ReactNode;
}

/**
 * "Qo'shish" formalari uchun modal oyna.
 *
 * Nega modal: bu formalar sahifaning DOIMIY qismi emas — operator kuniga bir marta band
 * qo'shadi, qolgan vaqtda esa ro'yxatni o'qiydi. Sahifa boshida turgan forma ro'yxatni pastga
 * surib, asosiy ishni ikkinchi o'ringa tushirardi.
 *
 * Oynaning o'zi ataylab JIMGINA chizilgan: bu yerda hech qanday bezak yo'q, chunki sahifadagi
 * yagona "kuchli" element kalendar paneli bo'lishi kerak. Bu shunchaki idish.
 *
 * Xato oyna ICHIDA qoladi va oyna yopilmaydi — server rad etgan formani yo'qotib yuborish
 * operatorni hamma maydonni qaytadan to'ldirishga majburlardi.
 */
export function FormDialog({
  open,
  onOpenChange,
  trigger,
  title,
  description,
  submitLabel,
  submitting,
  submitDisabled,
  onSubmit,
  error,
  children,
}: FormDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>

        <form className="flex flex-col gap-4" onSubmit={onSubmit}>
          {children}

          {error}

          <DialogFooter>
            <DialogClose asChild>
              <Button type="button" variant="outline" disabled={submitting}>
                {strings.common.cancel}
              </Button>
            </DialogClose>
            <Button type="submit" loading={submitting} disabled={submitDisabled}>
              {submitLabel}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
